import React from 'react';

export const HeartIcon = (props: { height: string; width: string; fillColor: string }) => {
  const { height, width, fillColor } = props;
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {fillColor ? (
          <path
            d="M10 19.175L8.55 17.855C3.4 13.185 0 10.105 0 6.32495C0 3.24495 2.42 0.824951 5.5 0.824951C7.24 0.824951 8.91 1.63495 10 2.91495C11.09 1.63495 12.76 0.824951 14.5 0.824951C17.58 0.824951 20 3.24495 20 6.32495C20 10.105 16.6 13.185 11.45 17.865L10 19.175Z"
            fill={fillColor}
          />
        ) : (
          <path
            d="M14.5 0.824951C12.76 0.824951 11.09 1.63495 10 2.91495C8.91 1.63495 7.24 0.824951 5.5 0.824951C2.42 0.824951 0 3.24495 0 6.32495C0 10.105 3.4 13.185 8.55 17.865L10 19.175L11.45 17.855C16.6 13.185 20 10.105 20 6.32495C20 3.24495 17.58 0.824951 14.5 0.824951ZM10.1 16.375L10 16.475L9.9 16.375C5.14 12.065 2 9.21495 2 6.32495C2 4.32495 3.5 2.82495 5.5 2.82495C7.04 2.82495 8.54 3.81495 9.07 5.18495H10.94C11.46 3.81495 12.96 2.82495 14.5 2.82495C16.5 2.82495 18 4.32495 18 6.32495C18 9.21495 14.86 12.065 10.1 16.375Z"
            fill="currentColor"
          />
        )}
      </svg>
    </>
  );
};
